import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDistanceToInclusions = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M13 5H8v5h5zm-1.024 9h24.048a1.69 1.69 0 0 1 1.365.695l6.45 8.868a.844.844 0 0 1-.063 1.068L24.62 45.383a.843.843 0 0 1-1.19.047q-.016-.014-16.742-18.132l-.004-.005-.03-.031-2.429-2.632a.84.84 0 0 1-.063-1.068l6.45-8.868A1.69 1.69 0 0 1 11.976 14m-3.35 9.163-.514.707L24 41.078l3.77-4.083A8.1 8.1 0 0 1 26 31.903C26 27.538 29.37 24 33.526 24c1.764 0 3.386.637 4.669 1.704l1.693-1.834-4.724-6.496h-13.76A8.2 8.2 0 0 1 20.3 21.28c-2.183 3.78-6.87 5.16-10.47 3.081-.64-.37-.995-.761-1.204-1.198M35 39.436 40.056 34l3.661 3.405-5.056 5.436z" })
});
export default SvgDistanceToInclusions;
